export const getComponentKey = () => Date.now() + Math.random()
